<template>
  <div style="width: 100%">
    <!--列表-->
    <el-table
      size="mini"
      stripe
      border
      :data="tableData"
      highlight-current-row
      expand-on-click-node="false"
      style="width: 100%"
    >
      <el-table-column prop="Channel" label="来源" width="70">
        <template slot-scope="scope">
          <el-tag type="info" v-if="scope.row.Channel == 0">未知</el-tag>
          <el-tag type="warning" v-if="scope.row.Channel == 1">点评</el-tag>
          <el-tag type="primary" v-if="scope.row.Channel == 2">美团</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="Tenant.Name" label="商家" width="100">
      </el-table-column>
      <el-table-column prop="Star" label="星级" width="70">
        <template slot-scope="scope">
          <el-tag type="success">{{ scope.row.Star / 10 }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="ReviewTime" label="评价时间" min-width="130">
        <template slot-scope="scope">
          {{ format.dateTimeFormat(scope.row.ReviewTime) }}
        </template>
      </el-table-column>
      <el-table-column prop="EmailAlertCounts" label="邮件提醒次数" width="120">
      </el-table-column>
      <el-table-column prop="Star" label="评价详情" width="150">
        <template slot-scope="scope">
          <div v-if="scope.row.ScoreDetails && scope.row.ScoreDetails.Items">
            <span
              v-for="item in scope.row.ScoreDetails.Items"
              :key="item.Key"
              type="success"
              >{{ item.Title }}:{{ item.Score }}</span
            ><br/>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="Star" label="交易详情" min-width="200">
        <template slot-scope="scope">
          <div v-if="scope.row.TradeDetails && scope.row.TradeDetails.Items">
            <div
              v-for="item in scope.row.TradeDetails.Items"
              :key="item.Key"
              type="success"
              >{{ item.Title }}:{{ item.Content }}</div
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="ConsumeTime" label="消费时间" width="120">
      </el-table-column>
      <el-table-column prop="ConsumeAmount" label="消费金额" width="100">
      </el-table-column>
      <el-table-column prop="ReviewQuality" label="评价质量" width="120">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.ReviewQuality == 1"
            >优质评价</el-tag
          >
          <el-tag type="danger" v-else>非优质评价</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="Description"
        label="商家备注"
        :show-overflow-tooltip="true"
        min-width="200"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.Description">
            <div v-for="desc in scope.row.Description.split('\n')" :key="desc">
              {{ desc }}
            </div>
          </div>
          <el-button
            @click="handleAddDesc(scope.row)"
            icon="el-icon-circle-plus"
            type="text"
          ></el-button>
        </template>
      </el-table-column>
      <el-table-column prop="InsertTime" label="下载时间" width="130">
        <template slot-scope="scope">
          {{ format.dateTimeFormat(scope.row.InsertTime) }}
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="pageSizesList"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :current-page.sync="pageIndex"
      ></el-pagination>
    </div>
    <addDesc ref="addDesc" />
  </div>
</template>
    <script>
import { getPageList } from "@/api/bussiness/commet";
import addDesc from "@/components/addDesc";
export default {
  components: {
    addDesc,
  },
  props: {
    filter: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    filter: {
      handler(val) {
        this.pageIndex = 1;
        this.getData();
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_API,
      loadInstance: "",
      tableData: [],
      total: 0,
      pageIndex: 1,
      pageSize: 5,
      pageSizesList: [5, 10, 15, 20, 30, 50],
    };
  },
  methods: {
    handleAddDesc(row) {
      this.$refs["addDesc"].Show(row, "Comment");
    },
    getData() {
      this.filter.pageIndex = this.pageIndex;
      this.filter.pageSize = this.pageSize;
      getPageList(this.filter).then((response) => {
        if (response) {
          this.tableData = response.Items;
          this.total = response.Total || response.Items.length;
        }
      });
    },
    handleSizeChange(val) {
      var pageSize = val;
      this.pageIndex = 1;
      this.pageSize = parseInt(pageSize);
      this.$nextTick(() => this.getData());
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getData();
    },
  },
  mounted() {
    //this.getData();
  },
};
</script>
    <style lang='scss' scoped>
.status {
  align-self: flex-end;
  font-size: 12px;
  font-weight: bold;
  color: #ff862f;
}
.statusdesc {
  align-self: flex-end;
  font-size: 12px;
  color: #797878;
}
.pagination {
  margin-top: 10px;
  text-align: right;
}
.link {
  color: #268bd2;
  text-decoration: underline;
  cursor: pointer;
}
</style>